import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
// import goalService from './goalService'
import { getAllService, getOneService } from "./services";


const initialState = {
    products: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''

}


//get goas
export const getProducts = createAsyncThunk('products/getAll', async (query:any,thunkAPI:any) => {
    try {
        const res = await getAllService(query);
        if (res?.status === 200) {

            return res?.data;

            
        }

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})

export const getOneProduct = createAsyncThunk('products/getOne', async (id:any,thunkAPI:any) => {
    try {
        const res = await getOneService(id);
        if (res?.status === 200) {

            return res?.data;

            
        }

    } catch (error:any) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)

    }

})





export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        productreset: (state:any) => initialState
    },
    extraReducers: (builder:any) => {
        builder.addCase(getProducts.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(getProducts.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.products.push(action.payload)

        })
        .addCase(getProducts.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload


        }).addCase(getOneProduct.pending, (state:any) => {
            state.isLoading = true

        })
        .addCase(getOneProduct.fulfilled, (state:any, action:any) => {
            state.isLoading = false
            state.isSuccess = true
            state.product = action.payload

        })
        .addCase(getOneProduct.rejected, (state:any, action:any) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload


        })
    }
})
export const { productreset } =  productSlice.actions
export default productSlice.reducer